import styled from "styled-components";
const EmptyListContentContainer = styled.div`
  /* height: 600px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
`;
const ImageBlockInnerShape = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
const EmptyListContentImageBlock1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 86px;
  border: 1px solid #d7d7d7;
  border-radius: 2px;
`;
const EmptyListContentImageBlock2 = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 80%;
  height: 34px;
  border: 1px solid #eaeaea;
  border-top: 0;
  border-radius: 2px;
`;
const EmptyListContentImageBlock3 = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 60%;
  height: 14px;
  border: 1px solid #eaeaea;
  border-top: 0;
  border-radius: 2px;
  margin-bottom: 34px;
`;
const EmptyListContent = (props) => {
  return (
    <EmptyListContentContainer className={` ${props.className}`}>
      <EmptyListContentImageBlock1>
        <ImageBlockInnerShape width="252px" height="8px" backgroundColor="#D7D7D7"></ImageBlockInnerShape>
        <ImageBlockInnerShape
          width="188px"
          height="9px"
          backgroundColor="#D7D7D7"
          style={{ marginTop: "11px" }}
        ></ImageBlockInnerShape>
      </EmptyListContentImageBlock1>
      <EmptyListContentImageBlock2>
        <ImageBlockInnerShape
          width="163px"
          height="5px"
          backgroundColor="#EAEAEA"
          style={{ marginTop: "7px" }}
        ></ImageBlockInnerShape>
      </EmptyListContentImageBlock2>
      <EmptyListContentImageBlock3></EmptyListContentImageBlock3>

      <div className="w-auto ff-univanova-600 fz-14 mb-2">Não encontramos nenhum dado</div>
      <div className="w-auto ff-univanova fz-14" style={{ color: "#8C8E98" }}>
        {props.description}
      </div>
    </EmptyListContentContainer>
  );
};

export default EmptyListContent;
